module.exports = __webpack_public_path__ + "img/test_cat_top.4c35eb99.png";